module.exports = __webpack_public_path__ + "img/approval.8538026b.svg";